import React from 'react';
import './css/MyStatsSkeletonLoader.css';

// This component displays a skeleton loader for the My Stats page.
function MyStatsSkeletonLoader() {
  return (
    <div className="stat-skeleton-loader">
      <div className="stat-skeleton-subheader"></div>
      <div className="stat-skeleton-progress-bar"></div>
      <div className="skeleton-stat-grid">
        {Array(8)
          .fill(0)
          .map((_, index) => (
            <div className="skeleton-stat-box" key={index}></div>
          ))}
      </div>
    </div>
  );
}

export default MyStatsSkeletonLoader;